import { IEntity, IHasOwner } from "./id-name";
import { IDeletedParam, IRequestParams } from "./page";

export enum DeletionStatus {
  Pending = "pending",
  Deleted = "deleted",
}

export enum DeletedConfigurationSortField {
  ArchiveId = "id",
  Bucket = "bucket",
  ExpiredAt = "expiredAt",
}

export interface IDeletedConfigurationDetailsItem extends IHasOwner, IEntity {
  bucket: string;

  data: Blob;

  expiredAt: Date;

  status: DeletionStatus;

  createdAt: Date;

  updatedAt: Date;
}

export interface IDeletedConfigurationListItem extends IHasOwner, IEntity<string> {
  bucket: string;

  expiredAt: Date;

  status: DeletionStatus;

  createdAt: Date;
}

export interface IDeletedConfigurationPageRequestParams
  extends IRequestParams<DeletedConfigurationSortField>, IDeletedParam {
  fields?: (keyof IDeletedConfigurationListItem)[];
}
